<div class="timecard-detail-header layout-row layout-align-start-center">
  @if (!isAgentView()) {
    <bz-button variant="tertiary" tone="primary" size="fit"
               appBringozIdGenerator="timecard-detail-back-button"
               [ariaLabel]="'Back' | translate"
               (clicked)="back.emit()">
      <bz-icon [icon]="icons.back"></bz-icon>
    </bz-button>
  }

  <!-- Agent select: an AngularJS widget, projected from the shell -->
  <ng-content></ng-content>

  <div class="date-navigation layout-row layout-align-center-center">
    <bz-button variant="tertiary" tone="primary" size="fit"
               appBringozIdGenerator="timecard-detail-previous-day-button"
               [ariaLabel]="'PreviousDay' | translate"
               (clicked)="browseDay.emit(false)">
      <bz-icon [icon]="icons.previous"></bz-icon>
    </bz-button>
    <app-bringoz-date-picker [date]="fromDate()"
                             [isHideLabel]="true"
                             [configTimeZone]="configTimeZone()"
                             (onChange)="dateChange.emit($event)">
    </app-bringoz-date-picker>
    <bz-button variant="tertiary" tone="primary" size="fit"
               appBringozIdGenerator="timecard-detail-next-day-button"
               [ariaLabel]="'NextDay' | translate"
               (clicked)="browseDay.emit(true)">
      <bz-icon [icon]="icons.next"></bz-icon>
    </bz-button>
  </div>

  <span class="flex"></span>

  <div class="header-actions gap-5 layout-row layout-align-end-center">
    <bz-button variant="tertiary" tone="secondary" size="fit"
               appBringozIdGenerator="timecard-detail-map-toggle-button"
               [ariaLabel]="'Map' | translate"
               (clicked)="toggleMapTimeline.emit()">
      <bz-icon [icon]="icons.map"></bz-icon>
    </bz-button>

    @if (isMapTimelineVisible()) {
      <bz-button variant="tertiary" tone="secondary" size="fit" class="margin-left-10"
                 appBringozIdGenerator="timecard-detail-route-panel-toggle-button"
                 [ariaLabel]="'Timeline' | translate"
                 (clicked)="toggleRoutePanel.emit()">
        <bz-icon [icon]="isRoutePanelVisible() ? icons.routePanelOpen : icons.routePanelClosed"></bz-icon>
      </bz-button>
    }

    <div *ngxPermissionsOnly="'timekeeping.timeCard.update'" class="margin-left-10">
      @if (addStopHint()) {
        <bz-tooltip placement="bottom" [content]="addStopHint() | translate">
          <ng-container *ngTemplateOutlet="addStopButton"></ng-container>
        </bz-tooltip>
      } @else {
        <ng-container *ngTemplateOutlet="addStopButton"></ng-container>
      }
    </div>

    <app-bringoz-site-nav-toggle class="margin-left-10"></app-bringoz-site-nav-toggle>
  </div>
</div>

<ng-template #addStopButton>
  <bz-button variant="outline" tone="secondary" size="md"
             appBringozIdGenerator="timecard-detail-add-stop-button"
             [disabled]="isAddStopDisabled()"
             (clicked)="addStop.emit()">
    <span>{{ 'Add Stop' | translate }}</span>
  </bz-button>
</ng-template>
